import React from "react";
import { FiMapPin } from "react-icons/fi";
import MapAddressField from "./MapAddressField";
import { PickupCard as Card, Label, I, FieldError, AirportPointRadio } from "./fields";

export default function PickupSection({
  v,
  set,
  errors,
  readOnly,
  placeIssue,
  onModeChange,
  onPlaceTyping,
  onPlaceSelect,
}) {
  const mapField = (placeholder) => (
    <MapAddressField
      side="pickup"
      v={v}
      city={v.city}
      readOnly={readOnly}
      placeIssue={placeIssue}
      onPlaceTyping={onPlaceTyping}
      onPlaceSelect={onPlaceSelect}
      placeholder={placeholder}
    />
  );

  return (
    <Card
      title="Pickup Details"
      subtitle="Starting point of the trip"
      icon={<FiMapPin className="w-5 h-5" />}
    >
      <div className="mb-3">
        <AirportPointRadio value={v.pickupMode} onChange={(val)=> onModeChange("pickup", val)} disabled={readOnly} />
      </div>

      {v.pickupMode === "AIRPORT" ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div data-field="pickupAirportName">
            <Label required>Airport Name</Label>
            <I value={v.pickupAirportName} onChange={set("pickupAirportName")} placeholder="e.g. IGI T3" readOnly={readOnly} invalid={!!errors.pickupAirportName} />
            <FieldError msg={errors.pickupAirportName} />
          </div>
          <div>
            <Label>Flight No. (optional)</Label>
            <I value={v.pickupFlightNo} onChange={set("pickupFlightNo")} placeholder="e.g. AI-123" readOnly={readOnly} />
          </div>
          <div className="md:col-span-2">
            {mapField("Search the airport or terminal on Google Maps")}
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div data-field="pickupAddress">
            <Label required>Exact Address</Label>
            <I value={v.pickupAddress} onChange={set("pickupAddress")} placeholder="House / building, street, landmark" readOnly={readOnly} invalid={!!errors.pickupAddress} />
            <FieldError msg={errors.pickupAddress} />
          </div>
          <div>
            {mapField("Search Google address")}
          </div>
        </div>
      )}
    </Card>
  );
}
